import { HttpHeaders } from '@angular/common/http';
import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { NbAuthJWTToken, NbAuthService, NbTokenService } from '@nebular/auth';
import { NbDateService } from '@nebular/theme';
import { RequestsService } from 'src/app/services/requests.service';
import { NotificationService } from 'src/app/services/unreadMesssages.service';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss']
})

export class ToolbarComponent implements OnInit {
  @Output() selectedLang = new EventEmitter<{ lang: string }>();
  @ViewChild('menuToggle') menuToggle!: ElementRef<HTMLInputElement>;

  user: any;
  token: NbAuthJWTToken;
  languages = [
    { code: 'en', name: 'English', isSelected: true, flag: './../assets/images/svgs/en.svg' },
    { code: 'gr', name: 'Ελληνικά', isSelected: false, flag: './../assets/images/svgs/gr.svg' },
    { code: 'es', name: 'Español', isSelected: false, flag: './../assets/images/svgs/es.svg' },
    { code: 'nl', name: 'Nederlands', isSelected: false, flag: './../assets/images/svgs/nl.svg' }
  ];
  selectedLanguageFlag = 'en';
  notifications = 0;
  gamification: any;

  menuItems = [
    { link: '/pages/dashboard', icon: 'dashboard', label: 'app.dashboard' },
    { link: '/pages/house-monitoring-panel', icon: 'devices', label: 'app.house-monitoring-panel' },
    { link: '/pages/analytics', icon: 'bar_chart', label: 'app.analytics' },
    { link: '/pages/gamification', icon: 'videogame_asset', label: 'app.gamification' },
    { link: '/pages/notifications', icon: 'notifications', label: 'app.alerts' },
    { link: '/pages/preferences', icon: 'settings', label: 'app.preferences' },
    { link: '/pages/about', icon: 'info', label: 'app.about-us' },
    { link: '/pages/my-account', icon: 'perm_identity', label: 'app.my-account' }
  ];

  constructor(private authService: NbAuthService, protected dateService: NbDateService<Date>,
    private nbTokenService: NbTokenService, private notificationService: NotificationService,
    private requestsService: RequestsService) {

    const today: Date = new Date();
    const firstDayOfCurrentMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const lastDayOfCurrentMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);

    const convertToStartOfDay = (date: Date): string => `${date.toISOString().split('T')[0]}T00:00:00.00Z`;
    const convertToEndOfDay = (date: Date): string => `${date.toISOString().split('T')[0]}T23:00:00.00Z`;

    this.requestsService.getNotifications(
      convertToStartOfDay(firstDayOfCurrentMonth),
      convertToEndOfDay(lastDayOfCurrentMonth)
    ).subscribe(response => {
      this.notifications = Array.isArray(response["data"]) ? response["data"].filter(item => !item.read).length : 0;
    });
    
    this.requestsService.getGameProfile().subscribe((data) => {
      this.gamification = data; 
    });

    this.authService.onTokenChange()
      .subscribe((token: NbAuthJWTToken) => {
        this.token = token;

        if (token.isValid()) {
          this.user = token.getPayload();
        }
      });
  }

  convert(str) {
    const date = new Date(str);
    const mnth = ("0" + (date.getMonth() + 1)).slice(-2);
    const day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

  closeMenu() {
    if (this.menuToggle?.nativeElement?.checked) {
      this.menuToggle.nativeElement.checked = false;
    }
  }

  logout() {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.token
      }),
    }

    this.nbTokenService.clear();
  }

  onChange(value: string) {
    this.languages.forEach(language => {
      language.isSelected = language.code === value;
    });
    this.selectedLang.emit({ lang: value });
    this.selectedLanguageFlag = value;
  }

  ngOnInit(): void {
    this.notificationService.notificationCount$.subscribe(count => {
      this.notifications = this.notifications - count;
    });
  }

}
